import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-securitylevel-dropdown',
  templateUrl: './SecurityLevelDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => SecurityLevelDropdownComponent)}]
})
export class SecurityLevelDropdownComponent extends BaseDropdownComponent {
    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getSecurityLevels().subscribe(x=> this.onGetSecurityLevelsDone(x));
    }
    
    onGetSecurityLevelsDone(items: ent.SecurityLevel[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}